import { type FC, memo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

import { useGetBingoEventQuery } from '@/api/queries/bingo';
import { opacityAnimation } from '@/common/config/motion-animations';
import { H3 } from '@/components/Typography/Typography';
import { PurpleButton } from '@/components/ui/Button/Button';

import { BuyBingoBallsContext } from '../context';

import { OfferItem } from './OfferItem';

interface ChooseOfferProps {
  nextStep: () => void;
}

const ChooseOffer: FC<ChooseOfferProps> = memo(({ nextStep }) => {
  const { t } = useTranslation();
  const { activeOfferIndex } = useContext(BuyBingoBallsContext);
  const { data: event } = useGetBingoEventQuery();
  const packages = event?.packages;

  return (
    <motion.div {...opacityAnimation} className="w-full px-4 pt-16">
      <div className="flex flex-col gap-2 w-full mb-10">
        {packages?.map((pkg, index) => (
          <OfferItem
            key={index}
            pkg={pkg}
            checked={activeOfferIndex === index}
            index={index}
          />
        ))}
      </div>
      <PurpleButton onClick={nextStep} className="mb-8">
        <H3 weight="extrabold" className="huge-text">
          {t('I’ll take this')}
        </H3>
      </PurpleButton>
    </motion.div>
  );
});

export { ChooseOffer };
